import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreate = () => {
  const {
    mutate: create,
    isPending,
    data,
  } = useAppMutation<{ id: string }>([QueryKey.CREATE_COMPANY], {
    mutationFn: () => ApiService.post({ endpoint: BackendRoute.COMPANIES }),
  });
  return { create, isPending, data };
};
